import { render } from "./MediumApi.vue?vue&type=template&id=4576b308&scoped=true"
import script from "./MediumApi.vue?vue&type=script&lang=js"
export * from "./MediumApi.vue?vue&type=script&lang=js"

import "./MediumApi.vue?vue&type=style&index=0&id=4576b308&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4576b308"]])

export default __exports__